import { createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';

import { InfoTooltip } from '@/components/atoms/InfoTooltip/InfoTooltip';
import { Rating } from '@/components/atoms/Rating';
import { Log } from '@/shared/types/analytics';
import { COLUMN_PRESETS } from '@/util/constants';

const columnHelper = createColumnHelper<Log>();

export const createCsatColumns = (t: TFunction) => [
  columnHelper.accessor('rating', {
    id: 'user_csat',
    header: () => t('analytics.fields.user_csat_column'),
    cell: ({ getValue }) => {
      const value = getValue();
      if (value == null) {
        return <div className="flex w-full items-center justify-start">-</div>;
      }
      return (
        <InfoTooltip content={t('analytics.fields.user_csat_tooltip')} showArrow>
          <div className="flex w-fit items-center justify-start">
            <Rating stars={value} className="[&_svg]:fill-primary [&_svg]:text-primary" />
          </div>
        </InfoTooltip>
      );
    },
    ...COLUMN_PRESETS.MD,
    meta: { preset: 'MD', label: 'analytics.fields.user_csat_column' },
  }),
  columnHelper.accessor('csat_brain', {
    id: 'ai_csat',
    header: () => t('analytics.fields.ai_csat_column'),
    cell: ({ getValue }) => {
      const value = getValue();
      if (value == null) {
        return <div className="flex w-full items-center justify-start">-</div>;
      }
      return (
        <InfoTooltip content={t('analytics.fields.ai_csat_tooltip')} showArrow>
          <div className="flex w-fit items-center justify-start">
            <Rating stars={value} className="[&_svg]:fill-ai [&_svg]:text-ai" />
          </div>
        </InfoTooltip>
      );
    },
    ...COLUMN_PRESETS.MD,
    meta: { preset: 'MD', label: 'analytics.fields.ai_csat_column' },
  }),
];
